import React from 'react'
import styled from 'styled-components'
import CSS from 'csstype'
import { Margins } from '../../constants'

const getSize = (size) => Margins[size]

type MarginSize = 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl' | 'xxxl' | 'zero'

interface StyledBoxProps {
  padding?: MarginSize
  paddingRight?: MarginSize
  paddingLeft?: MarginSize
  paddingTop?: MarginSize
  paddingBottom?: MarginSize
  margin?: MarginSize
  marginRight?: MarginSize
  marginLeft?: MarginSize
  marginTop?: MarginSize
  marginBottom?: MarginSize
  backgroundColor?: string
  border?: CSS.Property.Border
  roundedCorners?: boolean
}

const StyledBox = styled.div<StyledBoxProps>`
  ${(p) => {
    const styling = `
      ${p.border ? `border: ${p.border};` : ''}
      ${p.roundedCorners ? `border-radius: 15px;` : ''}
      ${p.backgroundColor ? `background-color: ${p.backgroundColor};` : ''}
    `

    if (p.margin !== 'zero' && p.padding !== 'zero') {
      return `margin: ${getSize(p.margin)}px;
              padding: ${getSize(p.padding)}px;
              ${styling}`
    }

    if (p.margin !== 'zero' && p.padding === 'zero') {
      return `margin: ${getSize(p.margin)}px; ${styling}`
    }

    if (p.margin === 'zero' && p.padding !== 'zero') {
      return `padding: ${getSize(p.padding)}px; ${styling}`
    }

    return `

      // Paddings
      ${p.paddingRight && `padding-right: ${getSize(p.paddingRight)}px;`}
      ${p.paddingLeft && `padding-left: ${getSize(p.paddingLeft)}px;`}
      ${p.paddingTop && `padding-top: ${getSize(p.paddingTop)}px;`}
      ${p.paddingBottom && `padding-bottom: ${getSize(p.paddingBottom)}px;`}

      // Paddings
      ${p.marginRight && `margin-right: ${getSize(p.marginRight)}px;`}
      ${p.marginLeft && `margin-left: ${getSize(p.marginLeft)}px;`}
      ${p.marginTop && `margin-top: ${getSize(p.marginTop)}px;`}
      ${p.marginBottom && `margin-bottom: ${getSize(p.marginBottom)}px;`}
      ${styling}
    `
  }}
`

interface BoxProps {
  padding?: MarginSize
  paddingRight?: MarginSize
  paddingLeft?: MarginSize
  paddingTop?: MarginSize
  paddingBottom?: MarginSize
  margin?: MarginSize
  marginRight?: MarginSize
  marginLeft?: MarginSize
  marginTop?: MarginSize
  marginBottom?: MarginSize
  backgroundColor?: CSS.Property.BackgroundColor
  border?: CSS.Property.Border
  roundedCorners?: boolean
  children?: React.ReactNode
}

export const Box = (props: BoxProps) => {
  const {
    padding = 'zero',
    paddingRight = 'zero',
    paddingLeft = 'zero',
    paddingTop = 'zero',
    paddingBottom = 'zero',
    margin = 'zero',
    marginRight = 'zero',
    marginLeft = 'zero',
    marginTop = 'zero',
    marginBottom = 'zero',
    backgroundColor,
    border,
    roundedCorners = false,
    children,
  } = props

  return (
    <StyledBox
      paddingRight={paddingRight}
      paddingLeft={paddingLeft}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      padding={padding}
      marginRight={marginRight}
      marginLeft={marginLeft}
      marginTop={marginTop}
      marginBottom={marginBottom}
      margin={margin}
      backgroundColor={backgroundColor}
      border={border}
      roundedCorners={roundedCorners}
    >
      {children}
    </StyledBox>
  )
}
